import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

const getAppLanguageSuccess = (data) => {
  const noAppLanguage = isObjectEmpty(data.Data)
  return {
    type: actionTypes.GET_APP_LANGUAGE,
    payload: {
      applanguage: noAppLanguage ? [] : data.Data,
    },
  };
};

export const getAppLanguage = () => async (dispatch) => {
  return await apiCall
    .axiosGet(`${API_BASE_URL}/GetSupportedLanguages`)
    .then((response) => {
      if (response) {
        dispatch(getAppLanguageSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};